import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Collection } from "./routes/Collection";
import { Help } from "./routes/Help";
import { ConnectGate, ForestFrame } from "./game-shell/GameShell";
import { Play } from "./routes/Play";
import { Profile } from "./routes/Profile";
import { Token } from "./routes/Token";
import { PlayerProvider } from "./state/PlayerContext";
import { useWallet, WalletProvider } from "./wallet/WalletProvider";

function GameEntry() {
  const { wallet, auth } = useWallet();
  return auth && wallet ? <Play key={wallet.address} /> : <ConnectGate />;
}

export function App() {
  return (
    <ErrorBoundary>
      <WalletProvider>
        <PlayerProvider>
          <BrowserRouter>
            <ForestFrame>
            <Routes>
              <Route path="/" element={<GameEntry />} />
              <Route path="/play" element={<GameEntry />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/token" element={<Token />} />
              <Route path="/help" element={<Help />} />
              <Route path="*" element={<GameEntry />} />
            </Routes>
            </ForestFrame>
          </BrowserRouter>
        </PlayerProvider>
      </WalletProvider>
    </ErrorBoundary>
  );
}
